import { Loader2, Sparkles } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import type { StandardSectionExtractionState } from '../hooks/useStandardSectionExtraction'

type StandardSectionExtractButtonProps = {
  extraction: StandardSectionExtractionState
  onClick: () => void
  size?: 'default' | 'sm' | 'lg' | 'icon'
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link' | 'destructive'
  className?: string
  labelOverride?: string
  /** Section chrome trigger — stays idle while the extraction dialog is open. */
  isExternalTrigger?: boolean
}

export function StandardSectionExtractButton({
  extraction,
  onClick,
  size = 'sm',
  variant = 'outline',
  className,
  labelOverride,
  isExternalTrigger = false,
}: StandardSectionExtractButtonProps) {
  const { t } = useTranslation('standardsLibrary')
  const {
    isExtracting,
    isTranslating,
    isApplying,
    extractDialogOpen,
  } = extraction

  const isDialogBusy = isExtracting || isTranslating || isApplying
  const showBusyState =
    isDialogBusy && (!isExternalTrigger || !extractDialogOpen)

  let idleLabel = t('detail.pdfSection.extractFromPdf')
  if (labelOverride != null && labelOverride !== '') {
    idleLabel = labelOverride
  }

  return (
    <Button
      type='button'
      size={size}
      variant={variant}
      className={className}
      onClick={onClick}
      disabled={showBusyState || (isExternalTrigger && extractDialogOpen)}
    >
      {showBusyState ? (
        <Loader2 className='mr-2 size-4 animate-spin' aria-hidden />
      ) : (
        <Sparkles className='mr-2 size-4' aria-hidden />
      )}
      {showBusyState ? t('detail.pdfSection.extracting') : idleLabel}
    </Button>
  )
}
